<form id="ocorrencia_maquina_form" name="ocorrencia_maquina_form" novalidate ng-submit="save(ocorrencia_maquina_form)">
  <ng-include src="'views/ocorrencias_maquinas/_ocorrencia_maquina_detalhes.html'"></ng-include>
  <div class="row pull-right padding-top-10" ng-include="'views/ocorrencias_maquinas/_ocorrencia_maquina_buttons.html'"></div>
</form>